<template>
  <div>
    <v-list nav dense>
      <v-list-item-group>
        <template v-for="(item, index) in items">
          <v-list-item
            :key="`item-${index}`"
            :to="{ name: `${item.name}` }"
            v-if="item.operator && !item.meta.group"
          >
            <v-list-item-icon :title="item.name">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.meta.nameDrawer }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-group
            v-else-if="item.operator"
            :key="item.name"
            :prepend-icon="item.action"
            :group="item.path"
          >
            <template v-slot:activator>
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title
                  v-text="item.meta.nameDrawer"
                ></v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item
              dense
              v-for="subItem in item.children"
              :key="subItem.meta.nameDrawer"
              :to="{ name: subItem.name }"
              v-show="subItem.meta.operator"
              v-model="item.meta.active"
              class="pl-8"
            >
              <v-list-item-action>
                <v-icon>{{ subItem.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title
                  v-text="subItem.meta.nameDrawer"
                ></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </template>
      </v-list-item-group>
    </v-list>
    <v-divider></v-divider>
    <v-list shaped dense>
      <v-list-item
        v-for="({ path, icon, text }, index) in homePages"
        :key="index"
        :to="{ path: path }"
      >
        <v-list-item-icon>
          <v-icon>{{ icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ text }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import RoutersUser from "../../user/router.config";
export default {
  name: "Sidebar",
  data: (vm) => ({
    items: [],
    homePages: [
      {
        icon: "mdi-home-outline",
        text: vm.$t("goToSports"),
        path: "/bt",
      },
      ...(vm.$store.state.operators.casino > 0 &&
      vm.$store.state.operators.credit == 2
        ? [
            {
              icon: "mdi-slot-machine-outline",
              text: vm.$t("goToCasino"),
              path: "/casino/lobby/casino",
            },
          ]
        : []),
    ],
  }),
  computed: {
    retail() {
      return this.$store.state.operators.retail;
    },
    credit() {
      return this.$store.state.operators.credit;
    },
    verificationSteps() {
      return this.$store.getters.getVerificationSteps;
    },
  },
  mounted() {
    this.items = RoutersUser;
    this.showDrawer();
  },
  methods: {
    showDrawer() {
      this.items.forEach((route) => {
        if (route.name == "MyPromotions" && this.credit != 2) {
          route.operator = false;
        }

        if (
          route.name === "Verify" &&
          (this.credit != 2 || this.verificationSteps.length === 0)
        ) {
          route.operator = false;
        }
        if (route.name === "Banco" && this.$isRetailSimplifiedOnly()) {
          route.operator = false;
        }
      });
    },
  },
};
</script>
